import dependencies from "../authentication/dependencies";
import { BASIC_PAGE_IDS } from "../config";
import { createBackendRequest } from "../mappers/backendMappers";

const { baseUrl, newBaseUrl, generalHeader } = dependencies;

// Map pathnames to basic page IDs
const getBasicPageId = (pathname) => {
  // Remove leading slash and any base path prefix, then convert to lowercase
  const cleanPath = pathname
    .replace(/^\//, "")
    .replace(/^devportalui\//, "")
    .replace(/^basicPage\//, "")
    .toLowerCase();

  if (cleanPath === "terms-and-conditions" || cleanPath === "terms") {
    return BASIC_PAGE_IDS.TERMS_AND_CONDITIONS;
  }
  if (cleanPath === "privacy-policy" || cleanPath === "privacy") {
    return BASIC_PAGE_IDS.PRIVACY_POLICY;
  }
  if (cleanPath === "oauth-document" || cleanPath === "oauth") {
    return BASIC_PAGE_IDS.OAUTH_DOCUMENT;
  }

  return null;
};

// The old Drupal backend aliases these pages as /terms and /privacy,
// not /terms-and-conditions and /privacy-policy (the new app's routes).
const getLegacyDrupalAlias = (pathname) => {
  const cleanPath = pathname
    .replace(/^\//, "")
    .replace(/^devportalui\//, "")
    .replace(/^basicPage\//, "")
    .toLowerCase();

  if (cleanPath === "terms-and-conditions" || cleanPath === "terms") {
    return "/terms";
  }
  if (cleanPath === "privacy-policy" || cleanPath === "privacy") {
    return "/privacy";
  }

  return pathname;
};

export const fetchBasicPage = async (pathname, csrfToken) => {
  // Check if this is a basic page that should be fetched from the new backend
  const basicPageId = getBasicPageId(pathname);

  if (basicPageId) {
    // Fetch from new backend
    try {
      const request = createBackendRequest({
        Id: basicPageId,
      });

      const res = await fetch(`${newBaseUrl}/BasicPage/get`, {
        method: "POST",
        headers: {
          ...generalHeader(csrfToken, true),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(request),
      });

      const response = await res.json();

      // Transform backend response to match expected format
      if (response?.payload || response?.Payload) {
        const payload = response.payload || response.Payload;
        return {
          data: payload,
          // Add any other fields expected by the mapper
        };
      }

      throw new Error("Invalid response from backend");
    } catch (error) {
      // Fall back to old backend silently
    }
  }

  // Fall back to old backend for other pages
  const url = baseUrl + getLegacyDrupalAlias(pathname) + "?_format=json";
  const res = await fetch(url, {
    headers: generalHeader(csrfToken, true),
  });
  return res.json();
};
